import FornecedorIndustriaList from '../../../produto/spa/fornecedor/industria/FornecedorIndustriaList';

export default FornecedorIndustriaList;
